<template>
  <footer class="bg-white w-full the-footer">
    <div class="w-full grid grid-cols-6 gap-4">
      <div class="col-span-2 logo">
        <a href="#">
          <img src="/logo/artfield-logo-black.png" alt="Black logo" class="mb-4">
        </a>
      </div>
      <div class="col-span-1" v-for="(item, index) in menuItems" :key="index">
        <ul>
          <li v-for="link in item.links" :key="link.name" class="f1">
            <a :href="link.url">{{ link.name }}</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script setup>
// Sample data for the footer columns
const menuItems = [
  { title: 'Community', links: [{ name: 'About', url: '/about' }, { name: 'Services', url: '/about?q=services' }, { name: 'Contact', url: '/about?q=contact' }] },
  { title: 'Legal Terms', links: [{ name: 'Help Center', url: '/help' }, { name: 'Privacy Policy', url: '/terms-and-conditions' }, { name: 'Terms and Conditions', url: '/terms-and-conditions?id=1' }, { name: 'Copyright & Trademark', url: '/terms-and-conditions?id=2' }, { name: 'Clarification Text', url: '/terms-and-conditions?id=3' }, { name: 'Cookie Policy', url: '/terms-and-conditions?id=4' }] },
  { title: 'Connect', links: [{ name: 'Instagram', url: 'https://www.instagram.com/artfieldofficial/' }, { name: 'Facebook', url: 'https://www.facebook.com/profile.php?id=61566942310312' }, { name: 'Linkedin', url: 'https://www.linkedin.com/company/artfieldofficial/' }] },
  { title: 'All Rights Reserved', links: [{ name: 'All rights reserved.', url: '#' }, { name: '© Artfield 2025', url: '#' }] }
];
</script>

<style scoped>
/* General styles */
.grid .col-span-1:last-child .f1 {
  margin-bottom: 10px !important;
}

/* The footer styles */
.the-footer {
  padding: 80px 40px;
}

/* Mobile-specific styles */
@media (max-width: 767px) {
  .logo {
    display: none; /* Hide the logo for mobile */
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2x2 grid */
    gap: 0;
  }

  ul {
    padding: 16px;
    margin: 0;
    border-bottom: 1px solid #000;
    height: 195px;
    width: 100%;
  }
  div.col-span-1:nth-child(2), div.col-span-1:nth-child(3) {
    border-top: 1px solid #000;
  }
  div.col-span-1:nth-child(2), div.col-span-1:nth-child(4) {
    border-right: 1px solid #000;
  }
  ul li {
    margin-bottom: 5px;
    font-size: 12px;
  }
  .the-footer {
    padding: 0;
    margin-bottom: 20px;
  }
  .col-span-1 {
    grid-column: span 1; /* Adjust each column to take up 1 grid column */
  }
  .grid .col-span-1:last-child .f1 {
    margin-bottom: 5px !important;
  }
}
</style>
